import Vue from "vue";
import Vuex from "vuex";

// module
import login from "./modules/login";
import masterUser from "./modules/masterUser";
import system from "./modules/system";
import karyawan from "./modules/karyawan";
import masterKaryawan from "./modules/master karyawan";
import fasilitas from "./modules/fasilitas";
import race from "./modules/race";
import health from "./modules/health";
import seragam from "./modules/seragam";
import skill from "./modules/skill";
import ownership from "./modules/ownership";
import institution from "./modules/institution";
import relationship from "./modules/relationship";
import terminateReason from "./modules/terminate_reason";
import diciplines from "./modules/diciplines";
import master_store from "./modules/master_store";
import education from "./modules/education";
import document_control from "./modules/document_control";
import jobexperience from "./modules/jobexperience";
import hobby from "./modules/hobby";
import history_career from "./modules/history_career";
import career_transisition from "./modules/careerTransisition";
import report_karyawan from "./modules/reportKaryawan";
import language from "./modules/language";
import assessment from "./modules/assessment";
import master_strata from "./modules/master_strata";

Vue.use(Vuex);

export default new Vuex.Store({
  namespaced: true,
  getters: {
    permissions(state) {
      return state.system.roles.menus.map(item => {
        return {
          name: item.name,
          permission: item.permission
        };
      });
    }
  },
  modules: {
    login,
    masterUser,
    system,
    karyawan,
    masterKaryawan,
    fasilitas,
    race,
    health,
    seragam,
    skill,
    hobby,
    ownership,
    institution,
    relationship,
    terminationReason: terminateReason,
    diciplines,
    master_location: master_store,
    userEdu: education,
    document_control,
    jobexperience,
    history_career,
    career_transisition,
    report_karyawan,
    language,
    assessment,
    master_strata
  }
});
